export var createMuiDialogTitleOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            padding: spacing(7, 12, 4),
        },
    });
};
//# sourceMappingURL=MuiDialogTitle.js.map